import React, { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import {
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  Button,
  styled,
} from '@deliveryhero/armor'

import {
  setCookieConsentAccepted,
  setCookieConsentRejected,
  shouldDisplayCookieNotice,
} from '../../utils/gtm'

const BottomRightDialog = styled(Dialog)`
  .Dialog-Window {
    position: absolute;
    bottom: 1.25em;
    right: 1.25em;
    max-width: 50em;
  }

  .DialogTitle-Text {
    font-size: 1em;
  }

  .DialogContent-Root {
    font-size: 0.875em;
  }

  @media (max-width: 800px) {
    .Dialog-Window {
      margin: 0;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: initial;
      max-height: initial;
      min-width: initial;
    }

    .DialogTitle-Text {
      font-size: 2em;
    }

    .DialogContent-Root {
      font-size: 1em;
    }

    .DialogActions-Root {
      flex-direction: column;

      button {
        overflow: hidden;
        margin-bottom: 1.5em;
        margin-right: 0;
      }
    }
  }
`

export const CookieNotice = ({
  primaryColor,
  cookiePolicyUrl,
}: {
  primaryColor: string
  cookiePolicyUrl: string
}) => {
  const { t } = useTranslation()

  const [open, setOpen] = useState(shouldDisplayCookieNotice())

  const onAccept = () => {
    setCookieConsentAccepted()
    setOpen(false)
  }

  const onReject = () => {
    setCookieConsentRejected()
    setOpen(false)
  }

  return (
    <BottomRightDialog open={open} onClose={onReject}>
      <DialogTitle>{t('LandingPage.CookieNoticeTitle')}</DialogTitle>
      <DialogContent>
        <Trans i18nKey="LandingPage.CookieNoticeDetails">
          cookie_notice_before_link
          <a
            rel="noreferrer noopener"
            target="_blank"
            href={cookiePolicyUrl}
            style={{ color: primaryColor }}
          >
            link_placeholder
          </a>
          cookie_notice_after_link
        </Trans>
      </DialogContent>
      <DialogActions>
        <Button
          secondary
          onClick={onReject}
          data-testid="cookie-modal-reject"
          style={{ color: primaryColor, borderColor: primaryColor }}
        >
          {t('LandingPage.CookieNoticeDecline')}
        </Button>
        <Button
          data-testid="cookie-modal-accept"
          onClick={onAccept}
          style={{ backgroundColor: primaryColor, borderColor: primaryColor }}
        >
          {t('LandingPage.CookieNoticeAccept')}
        </Button>
      </DialogActions>
    </BottomRightDialog>
  )
}
